module.exports = __webpack_public_path__ + "media/basic-details/meetup@3x-0fa7a8fe.png";